"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = exports.ActivePage = void 0;
var Preact = __importStar(require("preact"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var ConfigBottomMenu = __importStar(require("./A_ConfigBottomMenu"));
var DrawerTitle = __importStar(require("./A_DrawerTitle"));
var Slide_1 = __importDefault(require("@mui/material/Slide"));
var useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
var themes_1 = require("./themes");
var ConfigCardGroup = __importStar(require("./M_ConfigCardGroup"));
var QuestionCardGroup = __importStar(require("./M_QuestionCardGroup"));
var ActivePage;
(function (ActivePage) {
    ActivePage[ActivePage["QUESTIONS"] = 0] = "QUESTIONS";
    ActivePage[ActivePage["OPTIONS"] = 1] = "OPTIONS";
})(ActivePage = exports.ActivePage || (exports.ActivePage = {}));
var theme = (0, themes_1.getTheme)();
/**
 * This component handles both Question Panel and Option Panel in the Figma designs, due to how the MUI Transition components work
 * it is most straightforward to combine them into one component. See https://mui.com/material-ui/guides/composition/#caveat-with-refs
 *
 * Figma design nodes:
 * Mobile: https://www.figma.com/file/va7snk88pL7TR7F75h7zbt/Design-Files?node-id=9719%3A60338 &&  https://www.figma.com/file/va7snk88pL7TR7F75h7zbt/Design-Files?node-id=9715%3A60072
 * Desktop: https://www.figma.com/file/va7snk88pL7TR7F75h7zbt/Design-Files?node-id=9719%3A60567 && https://www.figma.com/file/va7snk88pL7TR7F75h7zbt/Design-Files?node-id=9719%3A60510
 */
var Component = function (p) {
    var isMobile = (0, useMediaQuery_1.default)(theme.breakpoints.down('md'));
    return (Preact.h(Box_1.default, { height: "100%", bgcolor: "background.paper", width: "100%", sx: {
            display: 'flex',
            paddingX: { xs: '0px', md: '16px 0px' },
            flexDirection: 'column',
            justifyContent: 'space-between',
        } },
        !isMobile && Preact.h(DrawerTitle.Component, { title: p.title }),
        Preact.h(Box_1.default, { sx: {
                padding: 0,
                height: '100%',
                overflow: 'hidden',
            }, position: "relative", id: "card-container" },
            Preact.h(Box_1.default, { height: "100%", sx: {
                    overflowX: { xs: 'scroll', md: 'hidden' },
                    overflowY: { xs: 'hidden', md: 'scroll' },
                } },
                Preact.h(QuestionCardGroup.Component, { onSelectQuestion: p.onSelectQuestion, nullOptionText: p.nullOptionText, questions: p.questions })),
            Preact.h(Slide_1.default, { timeout: { enter: 500, exit: 300 }, in: p.activePage === ActivePage.OPTIONS, direction: isMobile ? 'up' : 'left', mountOnEnter: !p.isSafari, unmountOnExit: !p.isSafari, style: { transitionDelay: p.isSafari ? '5ms' : '0ms' } },
                Preact.h(Box_1.default, { position: "absolute", top: 0, bgcolor: "background.paper", height: "100%", width: "100%", sx: {
                        overflowX: { xs: 'scroll', md: 'hidden' },
                        overflowY: { xs: 'hidden', md: 'scroll' },
                    } },
                    Preact.h(ConfigCardGroup.Component, { products: p.products, loading: p.incompatibleSelectionLoading, statusText: p.statusText, loadingText: p.loadingText, helperText: p.helperText, onSelectOption: p.onSelectOption, onBecomeVisible: p.onOptionBecomeVisible, nullOptionText: p.nullOptionText })))),
        Preact.h(ConfigBottomMenu.Component, { undo: p.incompatibleSelectionLoading ? undefined : p.undo, redo: p.incompatibleSelectionLoading ? undefined : p.redo, doneDisabled: p.incompatibleSelectionLoading, done: p.done, undoText: p.undoText, redoText: p.redoText, doneText: p.doneText })));
};
exports.Component = Component;
